import React from 'react';
import Email from '../components/Mail';
import { useTranslation } from "react-i18next";

const Footer = () => {
    const [t] = useTranslation("global");
    return (
    <section className='Footer' id='Footer'>
        <div className='Footer-container'>
            <h1 style={{textAlign:'center',paddingBottom:'20px'}}>{t("contact_me")}</h1>
            <div style={{display:'flex',justifyContent:'center'}}>
                <Email />
            </div>
            <span className='end'>leandro tateossian 2023 ® 💜 </span>
        </div>
    </section>
    )
}
export default Footer;